var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: "false",
    height: 17,
    width: 17,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M14.5,9.5h-5v5c0,0.6-0.4,1-1,1s-1-0.4-1-1v-5h-5c-0.5,0-1-0.4-1-1s0.5-1,1-1h5v-5c0-0.5,0.4-1,1-1 s1,0.5,1,1v5h5c0.6,0,1,0.4,1,1S15.1,9.5,14.5,9.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.a254e6cd90cc5e850517ad5a200ed0bf.svg";
export { ForwardRef as ReactComponent };